import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrambleTextPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin);

const InitScrambleText = () => {
  const CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXY';
  function makeScrambleText(
    selector = '.scrambleText',
    { duration = 1.2, ease = 'power2.out' } = {}
  ) {
    const chars = '-*dD';
    gsap.utils.toArray(selector).forEach((el) => {
      const originalText = el.textContent.trim();
      let randomStart = '';
      for (let i = 0; i < originalText.length; i++) {
        randomStart += CHARSET.charAt(
          Math.floor(Math.random() * CHARSET.length)
        );
      }
      el.textContent = randomStart;
      gsap.to(el, {
        scrambleText: {
          text: originalText,
          chars: chars,
          revealDelay: 0.5,
          speed: 0.3,
        },
        duration: duration,
        ease: ease,
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          toggleActions: 'play none none reverse',
        },
      });
    });
  }

  // 사용 예시
  document.addEventListener('DOMContentLoaded', () => {
    makeScrambleText('.scrambleText');
  });
};

export default InitScrambleText;
